import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Function to dynamically import all JSON files in the locales directory
// Files to go in src/locales/en/namespace.json and same for fr
// You can access the translations like this:
// t("namespace.hello")
const importAll = (r) => {
  let translations = {};
  r.keys().forEach((key) => {
    const pathParts = key.split("/");
    const lang = pathParts[1];
    const namespace = pathParts[2].replace(".json", "");

    if (!translations[lang]) {
      translations[lang] = { translation: {} };
    }

    translations[lang].translation = {
      ...translations[lang].translation,
      ...r(key),
    };
  });
  return translations;
};


// Use require.context to load all JSON files in the locales directory
// NOTE: require.context is webpack-only; in the SSR lambda bundle it’s shimmed to return no keys, so resources becomes empty if this module is imported server-side.
// Since this module also initializes i18next at import time, that can lock SSR into an empty resource set.
// If SSR might import this module indirectly, consider skipping require.context usage / i18n initialization in SSR entirely (or switch to a runtime loader similar to ssr/i18n-server).
const resources = importAll(require.context("../locales", true, /\.json$/));

// Set the initial language from storage or use the language from URL
// Handle SSR: localStorage and window may not be available
// NOTE: typeof window !== 'undefined' is not reliable for SSR in this project, because the SSR lambda build banner defines global.window, so this will evaluate to true during SSR.
// Use a more reliable browser check (e.g., check for document.createElement) or a dedicated SSR flag (global.__SSR__) and skip browser-only logic when running in SSR.
const isBrowser = typeof window !== "undefined" && !global.__SSR__;
let selectedLanguage = isBrowser ? localStorage.getItem("language") : null;
let defaultLanguage = "en"; // Define your default language

let languageFromURL = selectedLanguage || defaultLanguage;

// Check if the URL starts with /fr (this should include /fr followed by anything else)
if (isBrowser) {
  if (
    window.location.pathname.startsWith("/fr") ||
    window.location.pathname.startsWith("/fre")
  ) {
    languageFromURL = "fr";
  } else {
    languageFromURL = "en";
  }

  // Finally, set the determined language into local storage
  localStorage.setItem("language", languageFromURL);
}

//i18N Initialization

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "en", // Default language if detection fails
    lng: languageFromURL, // Set initial language from URL
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
